import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

/* Caja general para: Name + desplegable + Frase del día / Profesión y empresa */
export const StyledBoxName = styled.div`
  color: ${props => props.theme.colors.dark};
  display: none;
  flex-direction: column;
  justify-content: space-between;

  position: relative;
  text-align: right;
  ${props =>
    props.employee &&
    css`
      display: flex;
      justify-content: flex-start;
    `};
  ${mediaqueries.greaterThan('mobile')`
    text-align: left;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    text-align: right;
  `};
`;

/* Nombre */
export const StyledName = styled.div`
  line-height: ${rem('14px')};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.large};
  ${mediaqueries.greaterThan('mobile')`
    line-height: ${rem('32px')};
    font-size: ${rem('30px')};
    margin-bottom: ${rem('4px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('34px')};
    ${props => !props.userProfileView && `padding-right: ${rem('22px')};`}
    margin-left:auto;
  `};
`;

/* Texto profesión */
export const StyledProfession = styled.p`
  color: ${props => props.theme.colors.grayDarkest};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('13px')};
  margin-bottom: 0;
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.xlarge};
    margin-bottom: ${rem('3px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: inherit;
    margin-bottom: ${rem('8px')};
    padding-right: ${rem('22px')};
  `};
`;

/* Logo empresa */
export const StyledCompany = styled.img`
  width: ${rem('85px')};
  ${mediaqueries.greaterThan('mobile')`
    width: ${rem('108px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: ${rem('22px')};
    width: ${rem('138px')};
  `};
`;

/* Caja Frase del día */
export const StyledBoxParagraph = styled.div`
  text-align: right;
`;

/* Título frase del día */
export const StyledTitleParagraph = styled.p`
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('12px')};
  margin: 0;
  text-transform: uppercase;
`;

/* Párrafo frase del día */
export const StyledParagraph = styled.p`
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${props => props.theme.fontSize.small};
  margin: 0;
`;
